/**
 * Generates a WhatsApp link with a predefined phone number and message.
 * @param phoneNumber
 * @param message
 * @returns
 */
export function generateWhatsAppLink(
  phoneNumber: string,
  message: string,
): string {
  const encodedMessage = encodeURIComponent(message);
  const encodedPhone = phoneNumber.replace(/\D/g, ""); // Remove non-digit characters
  return `https://api.whatsapp.com/send/?phone=${encodedPhone}&text=${encodedMessage}`;
}
